import PROGRESS_STATES from "../requestProgressState";
import getRequestInfo from "./getRequestInfo";
export default function isPending(state, scope) {
    const requestInfo = getRequestInfo(state, scope);
    return Boolean(requestInfo && requestInfo.progressState === PROGRESS_STATES.INPROGRESS);
}
